/**********************************************************************************
import
***********************************************************************************************/

import React, {useState} from 'react';
import {View, StyleSheet, Modal, Alert, Pressable, Text, useWindowDimensions, Platform} from 'react-native';
import PropTypes from 'prop-types';

import { theme } from '../../config';
import RenderHtml from "react-native-render-html";
import {IconButton} from "react-native-paper";
import {markdownToHtml} from "../../services/utils";
import {useSelector} from "react-redux";
import DeviceInfo from "react-native-device-info";

function ModalInfo({ infoText }) {

  const [modalVisible, setModalVisible] = useState(false);
  const { width } = useWindowDimensions();
  const { fontScaleFactor } = useSelector(
      (state) => state.Globals,
  );

  const source = {
    html: '<div style="font-weight: bold; font-size: ' + fontScaleFactor * (DeviceInfo.isTablet() ? 1.75 : 1.2) + 'em">' + markdownToHtml(infoText) + '</div>'
  }

  return (
      <View style={styles.centeredView}>
        <Modal
            animationType="slide"
            transparent={true}
            visible={modalVisible}
            onRequestClose={() => {
              setModalVisible(!modalVisible);
            }}>
          <View style={styles.centeredView}>
            <View style={styles.modalView}>
              {Platform.OS === 'web' ? (<div
                dangerouslySetInnerHTML={{__html: source.html}}
              />) :
                (<RenderHtml
                    enableCSSInlineProcessing={true}
                    contentWidth={width}
                    source={source}
                />)
              }
              <Pressable
                  style={[styles.button, styles.buttonClose, (fontScaleFactor - 1) > 0 ? {padding: 20 * (fontScaleFactor - 1)} : {}]}
                  onPress={() => setModalVisible(!modalVisible)}>

                <IconButton
                    icon="close"
                    iconColor={'black'}
                    size={22}
                    mode={"contained"}
                    style={{marginRight: 10}}
                />
                <Text style={[styles.textStyle, { marginRight: 10, fontSize: 15 * fontScaleFactor}]}>Schließen</Text>
              </Pressable>
            </View>
          </View>
        </Modal>

        <Pressable
            style={[styles.button, styles.buttonOpen, (fontScaleFactor - 1) > 0 ? {padding: 20 * (fontScaleFactor - 1)} : {}]}
            onPress={() => setModalVisible(true)}>
          <IconButton
              icon="information"
              iconColor={'black'}
              size={22}
              mode={"contained"}
              style={{marginRight: 10 }}
          />
          <Text style={[styles.textStyle, { marginRight: 10, fontSize: 15 * fontScaleFactor}]}>Zusätzliche Erklärung anzeigen</Text>
        </Pressable>
      </View>
  );
}

ModalInfo.propTypes = {
  infoText: PropTypes.string.isRequired,
};

/***********************************************************************************************
local styling
***********************************************************************************************/

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 22,
  },
  modalView: {
    margin: 20,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 35,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  button: {
    flexDirection: "row",
    alignContent: "center",
    alignSelf: "center",
    alignItems: "center",
    borderRadius: 10,
  },
  buttonOpen: {
    backgroundColor: theme.colors.primary
  },
  buttonClose: {
    backgroundColor: theme.colors.primary,
    marginTop: 15
  },
  textStyle: {
    color: 'black',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'center',
  },
});

export default ModalInfo;
